<template>
  <div id="app">
    <keep-alive exclude="Detail">
      <!-- 显示的是当前路由地址所对应的内容 -->
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    // this.$wx.setConfig()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue